import omit from 'lodash/omit';
import { call, put, select } from 'redux-saga/effects';

import actions from '../../../actions';
import api from '../../../api';
import selectors from '../../../selectors';
import { createLocalId } from '../../../utils/local-id';
import request from '../request';

export function* createAttachment(cardId, data) {
  const localId = yield call(createLocalId);

  yield put(
    actions.createAttachment({
      cardId,
      id: localId,
      kind: 'file',
      name: data.file.name,
    }),
  );

  let attachment;
  try {
    ({ item: attachment } = yield call(request, api.createAttachment, cardId, data, localId));
  } catch (error) {
    yield put(actions.createAttachment.failure(localId, error));
    return;
  }

  yield put(actions.createAttachment.success(localId, attachment));
}

export function* createWireframe(cardId, data) {
  const localId = yield call(createLocalId);

  yield put(
    actions.createAttachment({
      cardId,
      id: localId,
      kind: 'wireframe',
      name: data.name,
      data: data.data,
      thumbnailSvg: data.thumbnailSvg,
      url: null,
      coverUrl: null,
    }),
  );

  let attachment;
  try {
    ({ item: attachment } = yield call(request, api.createWireframe, cardId, data, localId));
  } catch (error) {
    yield put(actions.createAttachment.failure(localId, error));
    return;
  }

  yield put(actions.createAttachment.success(localId, attachment));
}

export function* createAttachmentInCurrentCard(data) {
  const { cardId } = yield select(selectors.selectPath);

  if (data.kind === 'wireframe') {
    yield call(createWireframe, cardId, data);
  } else {
    yield call(createAttachment, cardId, data);
  }
}

export function* handleAttachmentCreate(attachment, requestId) {
  const isExists = yield select(selectors.selectIsAttachmentWithIdExists, requestId);

  if (!isExists) {
    yield put(actions.handleAttachmentCreate(attachment));
  }
}

export function* updateAttachment(id, data) {
  yield put(actions.updateAttachment(id, data));

  let attachment;
  try {
    if (data.kind === 'wireframe') {
      const requestData = omit(data, ['kind', 'updatedAt']);
      ({ item: attachment } = yield call(request, api.updateWireframe, id, requestData, data.updatedAt));
    } else {
      ({ item: attachment } = yield call(request, api.updateAttachment, id, data));
    }
  } catch (error) {
    yield put(actions.updateAttachment.failure(id, error));
    if (error.code === 'E_WIREFRAME_CONFLICT') {
      yield put(actions.handleWireframeUpdateConflict(id, error));
    }
    return;
  }

  yield put(actions.updateAttachment.success(attachment));
}

export function* handleAttachmentUpdate(attachment) {
  yield put(actions.handleAttachmentUpdate(attachment));
}

export function* deleteAttachment(id) {
  yield put(actions.deleteAttachment(id));

  let attachment;
  try {
    ({ item: attachment } = yield call(request, api.deleteAttachment, id));
  } catch (error) {
    yield put(actions.deleteAttachment.failure(id, error));
    return;
  }

  yield put(actions.deleteAttachment.success(attachment));
}

export function* handleAttachmentDelete(attachment) {
  yield put(actions.handleAttachmentDelete(attachment));
}

export default {
  createAttachment,
  createAttachmentInCurrentCard,
  handleAttachmentCreate,
  updateAttachment,
  handleAttachmentUpdate,
  deleteAttachment,
  handleAttachmentDelete,
};
